/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { CommonService} from './../common.service'
import { MapComponent} from './map.component'

@NgModule({
  declarations: [MapComponent],
  imports: [BrowserModule,CommonModule,FormsModule],
  providers: [CommonService],
  exports: [MapComponent],
  bootstrap: [MapComponent]
})

export class MapModule { }
